import axios from 'axios';
// import config from 'appConfig';

export default axios.create({
  baseURL: window.appConfig.API_URL,
  timeout: 0,
});
